import i18n from "i18next";
import { ProgressState } from "../application/ProgressState";
import { prettyPrintBytes } from "../application/FormattingUtils";

export function ProgressBar(container, showLabel = false) {

  let _document = container.ownerDocument;

  // .progresslb for typography, .progress-downloading-row for flex layout.
  this.downloadingRow = _document.createElement('div');
  this.downloadingRow.className = 'progresslb progress-downloading-row';
  this.downloadingRow.style.opacity = "0";

  this.downloadingText = _document.createElement('span');
  this.downloadingText.className = 'progress-downloading-text';
  this.downloadingText.setAttribute('data-i18n', 'ProgressDownloading');
  this.downloadingText.textContent = i18n.t('ProgressDownloading');

  this.bytesLabel = _document.createElement('span');
  this.bytesLabel.className = 'progress-bytes';

  this.downloadingRow.appendChild(this.downloadingText);
  this.downloadingRow.appendChild(this.bytesLabel);
  container.appendChild(this.downloadingRow);

  this.bg = _document.createElement('div');
  this.bg.className = 'progressbg';

  this.fg = _document.createElement('div');
  this.fg.className = 'progressfg';

  this.bg.appendChild(this.fg);
  container.appendChild(this.bg);

  this.lastValue = -1;

  this.fg.style.transform = `scale(0, 1)`;

  this.labels = [];
  this.showLabel = showLabel;

  // Add labels for the states from ProgressStates.js
  this.registerLabel(container, 'ProgressLoading'); // ROOT_LOADED
  this.registerLabel(container, 'ProgressLoading'); // LOADING
  this.registerLabel(container, 'ProgressRendering'); // RENDERING
  this.registerLabel(container, 'ProgressOptimizing'); // OPTIMIZING

  this._bytesFrameScheduled = false;
  this._latestLoaded = null;
  this._latestTotal = null;
}

ProgressBar.prototype.registerLabel = function (container, text) {
  const label = container.ownerDocument.createElement('div');
  label.className = 'progresslb';
  label.style.opacity = "0";
  label.setAttribute("data-i18n", text);
  label.textContent = i18n.t(text);

  this.labels.push(label);
  container.appendChild(label);
};

ProgressBar.prototype.setPercent = function (pct, state) {

  if (pct == this.lastValue)
  return;

  this.lastValue = pct;

  if (pct >= 100) {
    this.bg.style.opacity = "0";
    this.labels.forEach((label) => label.style.opacity = "0");
    this._hideDownloadingRow();
  } else {
    this.bg.style.opacity = "1";
    this.fg.style.transform = `scale(${pct / 100}, 1)`;
    if (this.showLabel) {
      this.labels.forEach((label, labelState) => label.style.opacity = state === labelState ? "1" : "0");
    }
    if (state !== ProgressState.DOWNLOADING) {
      this._hideDownloadingRow();
    }
  }
};

ProgressBar.prototype.setBytes = function (loaded, total) {
  this._latestLoaded = loaded;
  this._latestTotal = total;
  if (this._bytesFrameScheduled) return;
  this._bytesFrameScheduled = true;
  this.bytesLabel.ownerDocument.defaultView.requestAnimationFrame(() => {
    this._bytesFrameScheduled = false;
    if (this._latestLoaded == null || !this.bytesLabel.isConnected) return;
    const loadedBytes = Number.isFinite(this._latestLoaded) && this._latestLoaded > 0 ? this._latestLoaded : 0;
    const totalBytes = Number.isFinite(this._latestTotal) && this._latestTotal > 0 ? this._latestTotal : 0;

    const loadedStr = prettyPrintBytes(loadedBytes);
    const totalStr = prettyPrintBytes(totalBytes);
    this.bytesLabel.textContent = this._latestTotal ? `${loadedStr} / ${totalStr}` : loadedStr;
    this.downloadingRow.style.opacity = "1";
  });
};

ProgressBar.prototype._hideDownloadingRow = function () {
  this._latestLoaded = null;
  this._latestTotal = null;
  this.downloadingRow.style.opacity = "0";
  this.bytesLabel.textContent = '';
};

ProgressBar.prototype.setStyle = function (style) {
  !this.fg.classList.contains(style) && this.fg.classList.add(style);
};

ProgressBar.prototype.removeStyle = function (style) {
  this.fg.classList.contains(style) && this.fg.classList.remove(style);
};